
<div class="bg-light">
  <div class="container">
    <div class="row">
      <div id="login-art" class="col-md-6 d-none d-md-flex">

      </div>
      <div class="col-md-6 text-center">
        <div id="login-wrapper">
          <h2>{{page_header_text}}</h2>
          <ng-container  *ngIf="!reset_model?.is_link_expired">

            <form [formGroup]="form" method="post"  (ngSubmit)="submit()">
              <div>
                <mat-form-field>
                  <mat-label>Password</mat-label>
                <input matInput type="password" formControlName="password" required
                    validateEqual="confirm_password" autocomplete="off"/>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field>
                  <mat-label>Confirm Password</mat-label>
                <input matInput type="password" formControlName="confirm_password"
                    required validateEqual="password" reverse="true" autocomplete="off"/>
                </mat-form-field>
              </div>

              <p><button mat-raised-button type="submit" color="primary"
                  [disabled]="!form.valid">submit</button></p>

              <nexus-form-result [model]="form_result"></nexus-form-result>
              <div class="alert alert-warning" *ngIf="(!form.valid && (showPasswordErrors || showConfirmPasswordErrors))">
                <ul>
                  <ng-container  *ngIf="showPasswordErrors">
                    <li [class.valid]="passwordErrors?.hasUpperCase"><fa-icon [icon]="passwordErrors?.hasUpperCase ? faCheckCircle : faTimesCircle"></fa-icon>Contains Uppercase Letter</li>
                    <li [class.valid]="passwordErrors?.hasLowerCase"><fa-icon [icon]="passwordErrors?.hasLowerCase ? faCheckCircle : faTimesCircle"></fa-icon>Contains Lowercase Letter</li>
                    <li [class.valid]="passwordErrors?.hasNumeric"><fa-icon [icon]="passwordErrors?.hasNumeric ? faCheckCircle : faTimesCircle"></fa-icon>Contains Number</li>
                    <li [class.valid]="passwordErrors?.hasSpecial"><fa-icon [icon]="passwordErrors?.hasSpecial ? faCheckCircle : faTimesCircle"></fa-icon>Contains Special Character</li>
                    <li [class.valid]="passwordErrors?.hasMinLength"><fa-icon [icon]="passwordErrors?.hasMinLength ? faCheckCircle : faTimesCircle"></fa-icon>Contains Minimum 12 Characters</li>
                  </ng-container>
                  <ng-container  *ngIf="showConfirmPasswordErrors">
                    <li [class.valid]="confirmPasswordErrors"><fa-icon [icon]="confirmPasswordErrors ? faCheckCircle : faTimesCircle"></fa-icon>Confirm Password should match New Password</li>
                  </ng-container>

                </ul>
              </div>
            </form>
          </ng-container>

          <ng-container *ngIf="reset_model?.is_link_expired">
            <div class="row">
              <div class="alert alert-warning">
                The link has expired. Please <a class="grid-link" (click)="submit_reset_password()">click here</a> to resend it to your registered email address.
              </div>
              <nexus-form-result [model]="form_result"></nexus-form-result>
            </div>

          </ng-container>

        </div>
      </div>
    </div>
  </div>
</div>
